import { Alert } from "@heroui/react";
import { IoInformationCircle } from "react-icons/io5";

export default function CustomAlert({
    title,
    description = null,
    hideIconWrapper = false,
    variant,
    color,
    btnOne = null,
    btnTwo = null,
},) {

    return (
        <div className="flex items-center justify-center w-full my-4">
            <div className="flex flex-col w-full px-2">
                <Alert
                    key={color}
                    color={color || "primary"}
                    title={title}
                    description={description}
                    hideIconWrapper={hideIconWrapper}
                    variant={variant || "flat"}
                    icon={<IoInformationCircle />}
                    >
                    <div className="flex items-center gap-1 mt-3">
                       {btnOne}
                       {btnTwo}
                    </div>
                </Alert>
            </div>
        </div>
    );
}

